import { css } from '@emotion/react';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';

export const actionLessPageHeadingSmallMode = css`
  // Use media instead of container for this to work properly
  @media (max-width: ${breakpoints.xsmall.max}px) {
    margin-bottom: ${theme.spacing(1)};
  }
`;
